var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-chats-route-bridge text-center py-3"},[(_vm.opening)?_c('b-spinner',{attrs:{"variant":"primary"}}):_vm._e(),_c('p',{staticClass:"text-muted mt-1 mb-0"},[_vm._v(" جاري فتح المحادثات... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }